import {Component, Inject, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NotificacaoService} from '../../../../shared/services/notificacao/notificacao.service';
import {FinancasService} from '../../../../shared/services/financas/financas.service';
import {FormControl, Validators} from '@angular/forms';
import {Subscription} from 'rxjs/internal/Subscription';

@Component({
    selector: 'modal-adicionar-motivo-anulacao',
    template: `
    <section>
        <mat-progress-bar *ngIf="activarLoader" color="primary" mode="indeterminate"></mat-progress-bar>
        <div class="modal-header border-b" >
              <span mat-dialog-close class="cursor-pointer btn-close-modal">
                <mat-icon>close</mat-icon>
              </span>
                <div class="modal-title border-0">
                    <div class="bg-blue">
                        <h2 mat-dialog-title class="text-primary" color="primary">
                            Adicionar motivo da anulação
                        </h2>
                    </div>
                </div>
        </div>

        <div class="modal-body px-1 pb-1 k-form-crud" >
            <div fxLayout="row wrap"  >
                <div  fxFlex="100" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100"  class="pr-1 pt-02" >
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Motivo</mat-label>
                        <input matInput placeholder="Escrever novo motivo" type="text" autocomplete="off" [formControl]="motivoForm">
                    </mat-form-field>
                </div>
            </div>
          
            <div fxLayout="row wrap" class="sec-accao-modal border-t" >
                <div  fxFlex="100" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100"  class="p-1" >
                    <button class="bg-secondary" type="button" mat-button [mat-dialog-close]="true">Fechar</button>
                    <span fxFlex></span>
                    <button class="bg-primary" type="button" mat-button (click)="adicionarMotivo()">Gravar</button>
                </div>
            </div>
        </div>
    </section>
    `
}) export class ModalAdicionarMotivoAnulacaoComponent implements OnDestroy {
    motivoForm = new FormControl();
    subs: Subscription[] = [];
    codEstadoAnulado = 'A';
    activarLoader = false;
       constructor(
           @Inject(MAT_DIALOG_DATA) public dados: any,
           private alertService: NotificacaoService,
           private financaService: FinancasService,
           private modalRef: MatDialogRef<ModalAdicionarMotivoAnulacaoComponent>) { }

    adicionarMotivo() {
            if (!this.motivoForm.value) {
                this.motivoForm.setValidators([Validators.required]);
                this.motivoForm.markAsTouched({onlySelf: true});
                this.motivoForm.updateValueAndValidity({onlySelf: true});
                this.alertService.notificar('Preencha o motivo da anulação', false, 10000);
                return false;
            }
            const modelo  = {
                CodEstadoDocumento: this.codEstadoAnulado,
                MotivoEstado: this.motivoForm.value
            };
            this.activarLoader = true;
            this.subs.push(
                this.financaService.gravarMotivo(modelo).subscribe((res: any) => {
                   if(!res.mensagem) {
                     this.alertService.notificar('Motivo adiconado com sucesso!', true, 3000);
                   } else {
                     this.alertService.notificar(res.mensagem, true, 3000);
                   }
                   // this.alertService.notificar(JSON.stringify(res), true, 6000);
                    this.activarLoader = false;
                    this.motivoForm.reset();
                }, error => {
                    this.activarLoader = false;
                    this.alertService.notificar(JSON.stringify(error), false, 3000);
                })
            );

    } // Fim
    ngOnDestroy() {
        if (this.subs && this.subs.length > 0) {
         this.subs.forEach(sub => {sub.unsubscribe(); });
        }
    }

}
